import NotificationsScreen from './Notifications';

export {NotificationsScreen};
